import { Download, X, Share } from "lucide-react";

export const BannerInstalarFichaje = ({ ios, onInstalar, onCerrar }) => (
  <div
    className="fixed inset-x-3 bottom-3 z-[1000] mx-auto max-w-md rounded-2xl bg-[#1B2B4B] text-white shadow-2xl shadow-black/30 ring-1 ring-white/10 p-4 flex items-start gap-3 animate-in fade-in slide-in-from-bottom-4 duration-300"
    style={{ marginBottom: "env(safe-area-inset-bottom)" }}
    data-testid="pwa-install-banner"
    data-variante="fichaje"
  >
    <img src="/icons/fichaje-192.png" alt="" className="w-12 h-12 rounded-xl flex-shrink-0 ring-1 ring-white/15" />
    <div className="flex-1 min-w-0">
      <p className="font-bold text-sm leading-snug">Instala NuvliPro FICHAJE en tu móvil</p>
      {ios ? (
        <p className="text-xs text-slate-300 mt-1 leading-relaxed" data-testid="pwa-install-ios-hint">
          Pulsa el botón compartir <Share className="w-3.5 h-3.5 inline -mt-0.5 text-[#00B4CC]" aria-label="compartir" /> y selecciona{" "}
          <strong className="text-white">Añadir a pantalla de inicio</strong>.
        </p>
      ) : (
        <>
          <p className="text-xs text-slate-300 mt-1">Ficha más rápido: se abre a pantalla completa, como una app.</p>
          <button
            onClick={onInstalar}
            className="mt-2.5 inline-flex items-center gap-1.5 rounded-lg bg-[#00B4CC] hover:bg-[#00A0B6] active:scale-95 text-[#1B2B4B] text-xs font-bold px-4 py-2 transition-[background-color,transform]"
            data-testid="pwa-install-button"
          >
            <Download className="w-3.5 h-3.5" /> Instalar
          </button>
        </>
      )}
    </div>
    <button onClick={onCerrar} className="flex-shrink-0 p-1 text-slate-400 hover:text-white transition-colors" data-testid="pwa-install-dismiss" aria-label="Cerrar">
      <X className="w-4 h-4" />
    </button>
  </div>
);
